import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from 'recharts';

const BAR_COLORS = ['#074f78', '#2563EB', '#0891B2', '#16A34A', '#D97706', '#7C3AED', '#EC7426'];

export default function DashboardFunnelChart({ funnel, loading }) {
  const data = funnel || [];
  const hasData = data.some((r) => Number(r.count) > 0);

  return (
    <div className="db-card">
      <div className="db-card-header">
        <div className="db-card-title">
          <i className="fas fa-filter" style={{ color: '#074f78' }} />
          Onboarding funnel
        </div>
      </div>
      <div className="db-card-body">
        {loading ? (
          <div className="db-skeleton-block" />
        ) : !hasData ? (
          <div className="db-chart-empty">No funnel data yet — completes as users onboard</div>
        ) : (
          <div className="db-chart-wrap" role="img" aria-label="Onboarding funnel chart">
            <ResponsiveContainer width="100%" height={240}>
              <BarChart data={data} layout="vertical" margin={{ top: 4, right: 16, left: 8, bottom: 4 }}>
                <XAxis type="number" tick={{ fontSize: 11 }} allowDecimals={false} />
                <YAxis
                  type="category"
                  dataKey="label"
                  width={120}
                  tick={{ fontSize: 11 }}
                />
                <Tooltip
                  formatter={(value) => [value, 'Users']}
                  contentStyle={{ fontSize: 12, borderRadius: 8 }}
                />
                <Bar dataKey="count" radius={[0, 6, 6, 0]} maxBarSize={28}>
                  {data.map((_, i) => (
                    <Cell key={i} fill={BAR_COLORS[i % BAR_COLORS.length]} />
                  ))}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
        )}
      </div>
    </div>
  );
}
